export default {
  init() {
      let latitude = 37.926868;
      let longitude = -78.024902;
      let zoom = 8;

      var map;
      // eslint-disable-next-line no-undef
      map = new window.google.maps.Map(document.getElementById('map'), {
        center: {lat: latitude, lng: longitude},
        zoom: zoom,
      });

      new window.google.maps.Marker({
        position: {lat: 37.926868, lng: -78.024902},
        map,
        title: 'virgina',
      });



      $(document).on('click', '.region-name:not(".opened")', function() {
      $('.ministry-container').removeClass('active');
      $(this).children('.ministry-container').addClass('active');
      $(this).addClass('opened');
    }).children().on('click', '.locations-text', function(e) {
      e.stopPropagation();
    });

      $(document).on('click', '.opened h3', function() {
      $('.ministry-container').removeClass('active');
      $('.opened').removeClass('opened');
    });


    $('.back-btn').click(function (e){
      e.stopPropagation();
      $(this).parent().removeClass('active');
      $(this).parents('.region-name').siblings().show();
    });



    $('.r-2').click(function () {
      var lat;
      var long;

      $(this).addClass('chosen');

      let name = $(this).children('.map-info').children('.name').html();


      var url = 'https://maps.googleapis.com/maps/api/geocode/json?address=Purcellville,+VA&key=AIzaSyCK8px1LBnLGFOfUAZBNslwgmI1LFZVeyo'

      $.post( url, function( data ) {
        console.log(data.results[0]);
        if(data) {
          lat = data.results[0].geometry.location.lat
          long = data.results[0].geometry.location.lng;

          var cords = { lat: lat, lng: long};

          new window.google.maps.Marker({
            position: {lat: lat, lng: long},
            map,
            title: name,
          });

          map.panTo(cords);
          map.setZoom(12);
        }
      });

    });

    $('.r-1').click(function () {
      var lat;
      var long;

      $(this).addClass('chosen');

      let name = $(this).children('.map-info').children('.name').html();


      var url = 'https://maps.googleapis.com/maps/api/geocode/json?address=Leesburg,+VA&key=AIzaSyCK8px1LBnLGFOfUAZBNslwgmI1LFZVeyo'

      $.post( url, function( data ) {
        console.log(data.results[0]);
        if(data) {
          lat = data.results[0].geometry.location.lat
          long = data.results[0].geometry.location.lng;

          var cords = { lat: lat, lng: long};

          new window.google.maps.Marker({
            position: {lat: lat, lng: long},
            map,
            title: name,
          });

          map.panTo(cords);
          map.setZoom(12);
        }
      });

    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/centers.js